var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoBilda(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 373.7 159.8",
    style: {
      enableBackground: "new 0 0 373.7 159.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFD100;}\n\t.st1{fill:#2D2D2D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.5,90c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6s3.6-1.6,3.6-3.6S215.5,90,213.5,90z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M281.9,90c-2,0-3.6,1.6-3.6,3.6s1.6,3.6,3.6,3.6s3.6-1.6,3.6-3.6C285.6,91.6,283.9,90,281.9,90z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 44.9,
    cy: 114.9,
    r: 11.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.6,72.2V42c0-7.8,2-13.8,6-17.8c4-4.1,9.5-6.1,16.6-6.1s12.6,2,16.6,6s5.9,9.8,5.9,17.4v30.6h-11.9V59.8 h-21.5v12.4H310.6z M322.4,41.6v7.7h21.5V42c0-4.2-1-7.5-2.9-9.9s-4.5-3.5-7.9-3.5s-6,1.1-7.9,3.4 C323.4,34.2,322.4,37.4,322.4,41.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.8,18.3L105.8,18.3c-0.1,0-0.2,0-0.2,0c-14.9,0-27,12.1-27,27c0,5.5,1.6,10.7,4.7,15.3h-7.8v11.7h30.1h0.1 h0.1c14.9,0,27-12.1,27-27S120.7,18.3,105.8,18.3z M106.3,60.6h-0.9c-8.2-0.2-14.8-7-14.8-15.3c0-8.4,6.8-15.2,15.2-15.3 c8.4,0.1,15.2,6.9,15.2,15.3c0,8.1-6.3,14.7-14.2,15.2C106.6,60.5,106.4,60.6,106.3,60.6z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 105.7,
    cy: 45.2,
    r: 11.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 44.9,
    cy: 45.2,
    r: 11.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.4,89.8c1,0.9,1.5,2.2,1.5,3.8c0,1.6-0.5,2.9-1.4,3.8c-1,0.9-2.4,1.4-4.4,1.4h-3.4V88.4h3.6 C149,88.4,150.4,88.9,151.4,89.8z M151.1,93.6c0-2.4-1.4-3.6-4.1-3.6h-1.7v7.1h1.9c1.3,0,2.2-0.3,2.9-0.9 C150.8,95.6,151.1,94.8,151.1,93.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.9,91.8c0,1.7-0.7,2.8-2.2,3.2l2.7,3.8h-2.2l-2.5-3.5h-2.3v3.5h-1.7V88.4h3.8c1.6,0,2.7,0.3,3.4,0.8 S163.9,90.6,163.9,91.8z M161.5,93.2c0.4-0.3,0.5-0.8,0.5-1.5s-0.2-1.1-0.5-1.4c-0.4-0.3-1-0.4-2-0.4h-2.2v3.7h2.2 C160.5,93.6,161.2,93.6,161.5,93.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.3,88.4v1.6h-5.5v2.7h5v1.6h-5v2.8h5.7v1.6h-7.4V88.4H174.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.2,96.4l-1,2.4h-1.9l4.6-10.3h1.9l4.6,10.3h-1.9l-1-2.4H180.2z M184.6,94.8l-1.9-4.3l-1.9,4.3H184.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.7,98.8H191V88.4h2.7l3.1,6.5l3.1-6.5h2.7v10.3h-1.7v-8.1l-3.6,7.2h-1l-3.6-7.2V98.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.1,98.8h-1.7V88.4h2.7l3.1,6.5l3.1-6.5h2.7v10.3h-1.7v-8.1l-3.6,7.2h-1l-3.6-7.2V98.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M241.6,96.4l-1,2.4h-1.9l4.6-10.3h1.9l4.6,10.3h-1.9l-1-2.4H241.6z M246,94.8l-1.9-4.3l-1.9,4.3H246z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M252.3,88.4h1.7v5l4.7-5h2.2l-4.2,4.5l4.2,5.8h-2.1l-3.4-4.5l-1.5,1.6v2.9h-1.7L252.3,88.4L252.3,88.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M270.9,88.4v1.6h-5.5v2.7h5v1.6h-5v2.8h5.7v1.6h-7.4V88.4H270.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M301.1,91.8c0,1.7-0.7,2.8-2.2,3.2l2.7,3.8h-2.2l-2.5-3.5h-2.3v3.5h-1.7V88.4h3.8c1.6,0,2.7,0.3,3.4,0.8 C300.7,89.8,301.1,90.6,301.1,91.8z M298.7,93.2c0.4-0.3,0.5-0.8,0.5-1.5s-0.2-1.1-0.5-1.4c-0.4-0.3-1-0.4-2-0.4h-2.2v3.7h2.2 C297.7,93.6,298.4,93.6,298.7,93.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M312,88.4v1.6h-5.5v2.7h5v1.6h-5v2.8h5.7v1.6h-7.4V88.4H312z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M322.4,89.2c0.7,0.6,1.1,1.5,1.1,2.8s-0.4,2.2-1.1,2.8c-0.7,0.6-1.9,0.9-3.4,0.9h-1.8v3h-1.7V88.4h3.6 C320.5,88.4,321.7,88.6,322.4,89.2z M321.2,93.6c0.4-0.4,0.5-0.9,0.5-1.6s-0.2-1.2-0.7-1.5c-0.4-0.3-1.1-0.4-2.1-0.4h-1.8v4.1h2 C320.2,94.1,320.8,93.9,321.2,93.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334,88.4v1.6h-5.5v2.7h5v1.6h-5v2.8h5.7v1.6h-7.4V88.4H334z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.9,96.4l-1,2.4H336l4.6-10.3h1.9l4.6,10.3h-1.9l-1-2.4H338.9z M343.4,94.8l-1.9-4.3l-1.9,4.3H343.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M352.7,89.9v8.7H351v-8.7h-3.1v-1.6h8v1.6H352.7z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "128.3,99.3 104.1,99.3 75.6,99.3 75.6,93.5 75.6,87.8 104.1,87.8 128.3,87.8 132.7,93.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.6,72.2h-23.1V19.5H164c3.6,0,6.6,0.4,9.2,1.3c2.6,0.9,4.5,2,5.8,3.5c2.4,2.7,3.5,5.8,3.5,9.2 c0,4.1-1.3,7.2-4,9.2c-0.9,0.7-1.5,1.1-1.9,1.3s-1,0.5-1.9,0.9c3.3,0.7,5.9,2.2,7.8,4.4c1.9,2.2,2.9,5,2.9,8.3 c0,3.7-1.3,6.9-3.8,9.7C178.9,70.6,173.8,72.2,166.6,72.2z M155.3,40.8h5.6c3.3,0,5.7-0.4,7.3-1.1c1.6-0.7,2.4-2.2,2.4-4.6 c0-2.3-0.7-3.9-2.2-4.6c-1.5-0.8-3.9-1.1-7.4-1.1h-5.7L155.3,40.8L155.3,40.8z M155.3,62.2h8.1c3.4,0,5.9-0.4,7.6-1.2 c1.7-0.8,2.5-2.5,2.5-4.9s-0.9-4-2.7-4.8s-4.6-1.2-8.6-1.2h-6.9L155.3,62.2L155.3,62.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M204.8,62.1v10.1H193V62.1l0,0V29.6l0,0V19.5h11.8v10.1l0,0V62.1L204.8,62.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M213.5,72.2V19.5h11.8v42.2h22.5v10.5H213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M295.8,26.4c5,4.6,7.5,11,7.5,19.2S300.9,60.3,296,65c-4.9,4.8-12.4,7.2-22.4,7.2h-18V19.5h18.6 C283.5,19.5,290.8,21.8,295.8,26.4z M287.2,57.7c2.9-2.7,4.3-6.7,4.3-11.8c0-5.2-1.4-9.2-4.3-11.9c-2.9-2.8-7.3-4.2-13.3-4.2h-6.6 v32h7.5C280.1,61.8,284.3,60.4,287.2,57.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.9,18.5c-14.9,0-27,12.1-27,27s12.1,27,27,27h11.6V60.8H44.9c-8.4,0-15.3-6.9-15.3-15.3s6.9-15.3,15.3-15.3 s15.3,6.9,15.3,15.3v15.1l0,0V102l0,0v12.7c0,8.4-6.9,15.3-15.3,15.3s-15.3-6.9-15.3-15.3s6.9-15.3,15.3-15.3h11.6V87.7H44.9 c-14.9,0-27,12.1-27,27s12.1,27,27,27s27-12.1,27-27V45.5C71.9,30.6,59.8,18.5,44.9,18.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.1,15.7c0.7,0.7,1,1.4,1,2.4c0,0.9-0.3,1.7-1,2.4c-0.7,0.7-1.4,1-2.4,1c-0.9,0-1.7-0.3-2.4-1 c-0.6-0.7-1-1.4-1-2.4c0-0.9,0.3-1.7,1-2.4c0.7-0.7,1.4-1,2.4-1S357.4,15.1,358.1,15.7z M357.8,20.2c0.6-0.6,0.9-1.3,0.9-2.1 c0-0.8-0.3-1.5-0.8-2.1c-0.6-0.6-1.3-0.9-2.1-0.9c-0.8,0-1.5,0.3-2.1,0.9c-0.6,0.6-0.8,1.3-0.8,2.1c0,0.8,0.3,1.5,0.8,2.1 c0.6,0.6,1.2,0.9,2.1,0.9C356.5,21,357.2,20.8,357.8,20.2z M357.3,17.5c0,0.6-0.3,1-0.8,1.1l1,1.3h-0.8l-0.9-1.2H355v1.2h-0.6v-3.6 h1.4c0.5,0,0.9,0.1,1.2,0.3C357.2,16.7,357.3,17,357.3,17.5z M356.5,18c0.1-0.1,0.2-0.3,0.2-0.5s-0.1-0.4-0.2-0.5s-0.4-0.1-0.7-0.1 H355v1.3h0.7C356.2,18.1,356.4,18.1,356.5,18z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoBilda);
export default __webpack_public_path__ + "static/media/goBILDA.8abcecdeb64b67b2ab3f67d5f224c9ea.svg";
export { ForwardRef as ReactComponent };